import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, user, toggle,
    //------------- globalStates
    globalStates,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) => {

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllBanks = async () => {
        const { fetchAllBanks: { executeFetch } } = FetchData
        executeFetch()

    }

    const handleClickFetchSpecificBank = async (idbanco) => {

        const { FormScreen: { onResetForm } } = Forms

        const { fetchSpecificBank: { setParamsToSearch, executeFetch } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idbanco: idbanco })
        executeFetch()

        handleClickShowForm(true)

    }

    const handleClickToggleStateBank = async (idbanco, state) => {
        Swal.fire({
            title: '¿Está seguro de Desactivar este registro?',
            text: 'Esta acción hará que el registro sea removido de los listados de bancos que se encuentran en todo el sistema y no podrá asociar información a él',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/banco/toggleStateBank/${idbanco}`, { state })
                    .then(({ data }) => {

                        alertMessage(data)
                        handleClickFetchAllBanks()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickDeleteBank = async (idbanco) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/banco/deleteBanco/${idbanco}`)
                    .then(({ data }) => {

                        alertMessage(data)
                        handleClickFetchAllBanks()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })

    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const _dataBody = {
            idbanco: formState.idbank,
            nombre: formState.name,
            currency_type: formState.currency_type,
            estado: formState.state,
            usuario_creo: user.username,
            fecha_creo: new Date(),
            usuario_modifico: user.username,
            fecha_modifico: new Date()
        }

        if (_dataBody.idbanco > 0) {

            await marvarApi.put(`/banco/updateBanco/${_dataBody.idbanco}`, _dataBody)
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllBanks()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        } else {

            await marvarApi.post(`/banco/createBanco`, _dataBody)
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllBanks()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchSpecificBank,
        handleClickToggleStateBank,
        handleClickDeleteBank,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}